import React from "react";
import "./CompanyProfile.css";

export default function CompanyProfile() {
  return (
    <section id="company" className="company-profile reveal" data-delay="2">
      <div className="container">
        <div className="company-profile__content">
          <h2 className="company-profile__title">Company Profile</h2>
          <p className="company-profile__lead">
            We are a trusted partner in delivering innovative solutions tailored
            to your business needs. Our team brings years of expertise, a
            commitment to excellence, and a passion for driving measurable results.
            Since our inception, we have partnered with leading organizations to
            transform their digital presence and accelerate business growth.
          </p>

          <div className="company-profile__details">
            <div className="company-profile__item">
              <h3>Our Mission</h3>
              <p>
                To empower businesses through cutting-edge technology and
                strategic consulting. We believe in creating sustainable value
                by combining innovation with strategic foresight, helping our
                clients stay ahead in an increasingly competitive market.
              </p>
            </div>

            <div className="company-profile__item">
              <h3>Our Values</h3>
              <p>
                Innovation, Integrity, and Customer-centric approach define our
                every decision. We prioritize transparency, accountability, and
                continuous improvement in all our endeavors, ensuring our clients
                receive the highest quality of service.
              </p>
            </div>

            <div className="company-profile__item">
              <h3>Our Expertise</h3>
              <p>
                Digital transformation, software development, and strategic
                growth solutions. Our specialized teams have extensive experience
                across multiple industries, delivering proven results and
                sustainable business outcomes.
              </p>
            </div>
          </div>

          <div className="company-profile__section">
            <h3 className="company-profile__section-title">What We Offer</h3>
            <div className="company-profile__offerings">
              <div className="company-profile__offering">
                <h4>Custom Software Solutions</h4>
                <p>
                  Tailored applications built to your exact specifications, ensuring
                  seamless integration with your existing systems and processes.
                </p>
              </div>
              <div className="company-profile__offering">
                <h4>Digital Transformation</h4>
                <p>
                  End-to-end transformation services to modernize your operations,
                  improve efficiency, and unlock new revenue opportunities.
                </p>
              </div>
              <div className="company-profile__offering">
                <h4>Strategic Consulting</h4>
                <p>
                  Expert guidance to navigate complex business challenges and identify
                  growth opportunities aligned with your long-term vision.
                </p>
              </div>
              <div className="company-profile__offering">
                <h4>Technology Integration</h4>
                <p>
                  Seamless integration of cutting-edge technologies to optimize your
                  workflows and enhance operational performance.
                </p>
              </div>
            </div>
          </div>

          <div className="company-profile__section">
            <h3 className="company-profile__section-title">Why Choose Us</h3>
            <div className="company-profile__highlights">
              <div className="company-profile__highlight">
                <span className="company-profile__highlight-number">500+</span>
                <p>Projects Completed</p>
              </div>
              <div className="company-profile__highlight">
                <span className="company-profile__highlight-number">50+</span>
                <p>Industry Experts</p>
              </div>
              <div className="company-profile__highlight">
                <span className="company-profile__highlight-number">100%</span>
                <p>Client Satisfaction</p>
              </div>
              <div className="company-profile__highlight">
                <span className="company-profile__highlight-number">15+</span>
                <p>Years Experience</p>
              </div>
            </div>
          </div>

          <div className="company-profile__section">
            <h3 className="company-profile__section-title">Our Commitment</h3>
            <p className="company-profile__commitment-text">
              We are committed to delivering exceptional results through innovation,
              collaboration, and unwavering dedication to our clients' success. Our
              approach is grounded in understanding your unique challenges and crafting
              solutions that drive real, measurable impact. With a focus on long-term
              partnerships, we invest in your success and work tirelessly to exceed expectations.
            </p>
          </div>

          <div className="company-profile__cta">
            <a
              className="company-profile__download-btn"
              href="/company-profile.pdf"
              download
            >
              Download Company Profile
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
